package top.wcpe.allincore.ui.web.docs

import top.wcpe.allincore.ui.web.asset.PreviewDependencyRegistry

/**
 * FR-UI-069 docs 模式组件依赖登记表。
 *
 * 现委托 [WikiMuseumDependencyRegistry]，同时覆盖文档组件与 wiki 博物馆壳，
 * 以及 10 套 ui-themes bareName。
 */
internal object DocsDependencyRegistry {
    fun create(): PreviewDependencyRegistry = WikiMuseumDependencyRegistry.create()
}
